import { fetchFreeTrialOrderDeliveryLimits, fetchOrderDeliveryLimits, selectOrderDeliveryLimits, useSelector, } from "@jti/store";
import { useFreeTrial } from "../hooks/useFreeTrial";
const useShipping = () => {
    const { isFreeTrial, freeTrialId } = useFreeTrial();
    const orderDeliveryLimits = useSelector(selectOrderDeliveryLimits);
    const freeTrialDeliveryLimits = useSelector((state) => state.freeTrialCart.checkout.orderDeliveryLimits.data);
    const cartId = useSelector((state) => state.cart.id);
    const isTrialEligible = useSelector((state) => state.freeTrialCart.isTrialEligible);
    return {
        isFreeTrial,
        isTrialEligible,
        cartId: isFreeTrial ? freeTrialId : cartId,
        orderDeliveryLimits: isFreeTrial ? freeTrialDeliveryLimits : orderDeliveryLimits,
        fetchDeliveryLimit: isFreeTrial ? fetchFreeTrialOrderDeliveryLimits : fetchOrderDeliveryLimits,
    };
};
export default useShipping;
//# sourceMappingURL=useShipping.js.map